import { EmptyState } from '../Kit/_index';
import { onFormatShort, onResolveMax } from './_chartScale';

const BLOCK = 'LStudio__app_chart';

/*
    🔥 BARRAS HORIZONTALES

    ⚠️ CUÁNDO USAR ESTAS Y NO LAS VERTICALES

    Cuando las etiquetas son largas —nombres de productos, países,
    vendedores— o cuando hay más de diez categorías. En vertical esas
    etiquetas terminan rotadas 45 grados, que es la forma más común de
    hacer ilegible un gráfico.

    ⚠️ NO ES SVG

    Acá el ancho de cada barra es un porcentaje de un div. Sin eje Y
    compartido ni escalado que deformar, el HTML alcanza y encima
    permite que la etiqueta y el valor sean texto seleccionable.
*/

export const ChartBarH = ({
    data = [],  tone = 'accent',  max = null,
    showValues = true,  isSorted = true,
    limit = null,  formatValue = onFormatShort,  emptyLabel = 'Sin datos para graficar',
    ariaLabel = 'Gráfico de barras horizontales',
}) => {

    if (!data.length) return <EmptyState title={emptyLabel} size="sm" />;

    const CLEAN = data.map((d) => ({ ...d, value: Number(d.value) || 0 }));

    const SORTED = isSorted ? [...CLEAN].sort((a, b) => b.value - a.value) : CLEAN;

    const ROWS = limit ? SORTED.slice(0, limit) : SORTED;

    const MAX = onResolveMax(ROWS.map((d) => d.value), max);

    return (
        <div className={`${BLOCK}_barh`} role="img" aria-label={ariaLabel}>
            {
                ROWS.map((item, index) => (
                    <div key={item.label ?? index} className={`${BLOCK}_barh__row`}
                        data-tone={item.tone ?? tone} >

                        <span className={`${BLOCK}_barh__label`} title={item.label}>{item.label}</span>

                        <span className={`${BLOCK}_barh__track`}>
                            <span
                                className={`${BLOCK}_barh__fill`}
                                style={{ width: `${Math.max(1, (item.value / MAX) * 100)}%` }}
                            />
                        </span>

                        {
                            showValues && (
                                <span className={`${BLOCK}_barh__value`}>{formatValue(item.value)}</span>
                            )
                        }

                    </div>
                ))
            }

            {
                limit && SORTED.length > limit && (
                    <p className={`${BLOCK}_barh__more`}>
                        y {SORTED.length - limit} categorías más
                    </p>
                )
            }
        </div>
    );
};
